import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { patientAgentMessages } from '../config';

import styles from './AgentChat.module.scss';

type ConversationSkeletonProps = {
  className?: string;
};

export const ConversationSkeleton: FC<ConversationSkeletonProps> = ({
  className,
}) => {
  const { formatMessage } = useIntl();
  return (
    <div
      className={cn(styles.conversationSkeleton, className)}
      role="status"
      aria-label={formatMessage(patientAgentMessages.loadingConversation)}
    >
      <span className={styles.skeletonUserMessage} />
      <div className={styles.skeletonAssistantMessage}>
        <span />
        <span />
        <span />
      </div>
      <div className={styles.skeletonActivity}>
        <i />
        <span />
      </div>
    </div>
  );
};
